<div class="reports-form">
  <ng-container [formGroup]="reportForm">
    <div class="reports-form__body">
      <p>Report Target *</p>
      <mat-radio-group
        class="reports-form__kind"
        formControlName="kind"
        (change)="onKindChange()"
        required
      >
        <mat-radio-button value="entity">Entity</mat-radio-button>
        <mat-radio-button value="query">Query</mat-radio-button>
        <mat-radio-button value="portfolio">Portfolio</mat-radio-button>
      </mat-radio-group>

      <div class="reports-form__row">
        <mat-form-field
          appearance="outline"
          class="field-search"
          *ngIf="currentKind === 'portfolio' || currentKind === 'query'"
        >
          <mat-label>{{
            currentKind === 'query' ? 'Saved Query' : 'Portfolio'
          }}</mat-label>
          <mat-select
            formControlName="reportObject"
            [panelClass]="currentKind === 'query' ? 'query-select-panel' : ''"
            disableOptionCentering
            required
          >
            <ng-container [ngSwitch]="currentKind">
              <ng-container *ngSwitchCase="'portfolio'">
                <mat-option
                  *ngFor="let option of folio$ | async | orderBy: 'name'"
                  [value]="option.uid"
                  [disabled]="!canReportPortfolio(option)"
                  [matTooltip]="
                    !canReportPortfolio(option)
                      ? portfolioTooFewCompaniesTooltip
                      : ''
                  "
                  matTooltipPosition="right"
                >
                  {{ option.name }}
                  <span
                    class="option-reason"
                    *ngIf="!canReportPortfolio(option)"
                  >
                    — fewer than 6 companies
                  </span>
                </mat-option>
              </ng-container>
              <ng-container *ngSwitchCase="'query'">
                <mat-optgroup
                  *ngFor="let group of queryGroups$ | async"
                  [label]="group.name"
                >
                  <mat-option
                    *ngFor="let option of group.queries | orderBy: 'name'"
                    [value]="option.uid"
                    >{{ option.name }}</mat-option
                  >
                </mat-optgroup>
              </ng-container>
            </ng-container>
          </mat-select>
        </mat-form-field>

        <mat-form-field
          appearance="outline"
          class="field-search"
          *ngIf="currentKind === 'entity'"
        >
          <mat-label>Search company</mat-label>
          <input
            matInput
            type="text"
            [matAutocomplete]="menuSearch"
            [formControl]="searchFormControl"
            required
          />
          <mat-autocomplete
            #menuSearch="matAutocomplete"
            (optionSelected)="onOptionSelected($event.option.value)"
            [autoActiveFirstOption]="true"
            class="searchLetter search-panel"
            panelWidth="auto"
          >
            <ng-container *ngIf="searchItems$ | async as search">
              <ng-container
                *ngFor="
                  let items of search.hits
                    | groupBy: 'entity.type'
                    | orderByType
                    | pairs
                "
              >
                <mat-optgroup>
                  <div class="optgroup-search">
                    <div class="indexo-left">{{ items[0] | nicetxt }}</div>
                    <div class="indexo-right">
                      <div class="optgroup-column column-1">Country</div>
                      <div class="optgroup-column"># Articles</div>
                    </div>
                  </div>
                  <ng-container *ngFor="let option of items[1]">
                    <mat-option
                      *ngIf="!option.entity.hasParent"
                      [value]="option"
                    >
                      <div class="search-indexo">
                        <div class="indexo-left">
                          <span>{{ option.entity.name }}</span>
                          <span class="match">{{
                            option.entity.matched_form
                              ? option.entity.matched_form
                              : ''
                          }}</span>
                        </div>
                        <div class="indexo-right">
                          <div class="optgroup-column column-1">
                            {{
                              option.entity?.country?.alpha_id
                                ? option.entity.country.alpha_id.toUpperCase()
                                : '—'
                            }}
                          </div>
                          <div class="optgroup-column">
                            {{ numberFormat(option.count) }}
                          </div>
                        </div>
                      </div>
                    </mat-option>
                    <mat-option
                      *ngFor="let optionChild of option.entity.children"
                      [value]="optionChild"
                    >
                      <div class="search-indexo">
                        <div class="indexo-left">
                          <span class="subsidiary">{{
                            optionChild.entity.name
                          }}</span>
                          <span
                            class="match"
                            *ngIf="iMatch(optionChild.entity)"
                            >{{
                              optionChild.entity.matched_form
                                ? optionChild.entity.matched_form
                                : ''
                            }}</span
                          >
                        </div>
                        <div class="indexo-right">
                          <div class="optgroup-column column-1">
                            {{
                              optionChild.entity?.country?.alpha_id
                                ? optionChild.entity.country.alpha_id.toUpperCase()
                                : '—'
                            }}
                          </div>
                          <div class="optgroup-column">
                            {{ numberFormat(optionChild.count) }}
                          </div>
                        </div>
                      </div>
                    </mat-option>
                  </ng-container>
                </mat-optgroup>
              </ng-container>
            </ng-container>
          </mat-autocomplete>
          <mat-spinner [diameter]="15" *ngIf="loadingSearch"></mat-spinner>
        </mat-form-field>

        <mat-form-field appearance="outline" class="field-type">
          <mat-label>Report type</mat-label>
          <mat-select
            *ngIf="currentKind !== 'query'; else singleReportType"
            formControlName="reportType"
            panelClass="query-select-panel"
            disableOptionCentering
            required
          >
            <mat-optgroup
              *ngFor="let group of reportTypeGroups; trackBy: trackByGroupLabel"
              [label]="group.label"
            >
              <mat-option
                *ngFor="
                  let option of group.options;
                  trackBy: trackByOptionValue
                "
                [value]="option.value"
                >{{ option.label }}</mat-option
              >
            </mat-optgroup>
          </mat-select>
          <ng-template #singleReportType>
            <input matInput readonly value="Credit Due Diligence" />
          </ng-template>
        </mat-form-field>
      </div>

      <div class="reports-form__schedule">
        <div class="reports-form__schedule-label-row">
          <span>Schedule</span>
          <span
            class="reports-form__schedule-hint"
            *ngIf="currentScheduleHint"
            >{{ currentScheduleHint }}</span
          >
        </div>
        <app-segmented-tabs
          [options]="scheduleTabs"
          [value]="reportForm.get('schedule')?.value"
          (valueChange)="reportForm.get('schedule')?.setValue($event)"
        ></app-segmented-tabs>
      </div>

      <mat-form-field appearance="outline" class="field-type">
        <mat-label>Additional Recipients from {{ domain }}</mat-label>
        <mat-chip-list #chipListAlertRecipients aria-label="Email selection">
          <mat-chip
            *ngFor="let item of emailList"
            [selectable]="true"
            [removable]="true"
            (removed)="removeEmail(item)"
          >
            {{ item }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
          <input
            matInput
            [matChipInputFor]="chipListAlertRecipients"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="true"
            (matChipInputTokenEnd)="addEmail($event)"
          />
        </mat-chip-list>
      </mat-form-field>
    </div>

    <div class="reports-form__actions">
      <button
        *ngIf="!isNewReport"
        type="button"
        class="reports-form__btn reports-form__btn--ghost"
        (click)="deleteReport()"
      >
        <mat-icon class="reports-form__btn-icon">delete</mat-icon>
        <span>Delete</span>
      </button>

      <button
        type="button"
        class="reports-form__btn reports-form__btn--primary"
        (click)="saveReport()"
        [disabled]="!reportForm.valid"
      >
        <mat-icon class="reports-form__btn-icon">save</mat-icon>
        <span>Save &amp; enable</span>
      </button>
    </div>
  </ng-container>
</div>
